import { StrictMode } from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import { QueryClientProvider } from "react-query"
// import { ReactQueryDevtools } from "react-query/devtools"
import { queryClient } from "./api/query"
import { addLocale, locale } from "primereact/api"
import App from "./App"

import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeflex/primeflex.css"
import "primeicons/primeicons.css"
import "./style/global.css"
import "flag-icons/css/flag-icons.min.css"

addLocale("cs", {
  firstDayOfWeek: 1,
  dayNames: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"],
  dayNamesShort: ["ne", "po", "út", "st", "čt", "pá", "so"],
  dayNamesMin: ["ne", "po", "út", "st", "čt", "pá", "so"],
  monthNames: ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září",
    "říjen", "listopad", "prosinec"],
  monthNamesShort: ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis",
    "pro"],
  today: "dnes",
  clear: "vymazat",
  choose: "Vybrat",
})
locale("cs")

ReactDOM.render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
        {/* <ReactQueryDevtools initialIsOpen={true} /> */}
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
  document.getElementById("root")
)
